import React, { useEffect, useRef } from 'react';
import { loadAccessToken, loadTokenFromUrl } from '../services/auth.service';
import { getUserProfileData } from '../services/user.service';
import { useUserDetails } from '../recoil/hooks/useUserState';
import { setTokens } from '../utils/tokens';

export default function AuthWrap() {
  const [user, setUser] = useUserDetails();
  const isFetchingRef = useRef(false);

  useEffect(() => {
    // Prevent concurrent auth attempts
    if (isFetchingRef.current) return;
    isFetchingRef.current = true;

    // Try URL token first (cross-app SSO from user-ui), fall back to cookie refresh
    const urlToken = loadTokenFromUrl();
    const authPromise = urlToken
      ? (setTokens(urlToken, '', false), Promise.resolve())
      : loadAccessToken();

    authPromise
      .then(() => {
        return getUserProfileData();
      })
      .then((userData) => {
        if (userData) {
          setUser(userData);
        }
      })
      .catch((err) => {
        // Don't treat rate limiting as a fatal error
        if (err?.response?.status === 429) {
          console.warn('Rate limited during auth - will retry on next interaction');
          return;
        }
        // For 401/403, the user simply isn't logged in via cookie - this is expected for Trade UI
        if (err?.response?.status === 401 || err?.response?.status === 403) {
          console.log('No valid session cookie - user needs to login via User UI first');
          return;
        }
        console.error('Auth error:', err);
      })
      .finally(() => {
        isFetchingRef.current = false;
      });
  }, [setUser]);

  return null;
}
